export const mediaSettings = {
  perPage: 20
};
